import { motion } from "framer-motion";
import { MapPin, Phone, Globe, Clock } from "lucide-react";
import { Link } from "react-router-dom";

export const FooterSection = () => {
  return (
    <footer id="footer" data-testid="contact-section" className="relative py-16 sm:py-20 bg-[#1A1A1A]">
      <div className="container mx-auto px-6 sm:px-8 max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8 mb-16">
          <div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 inline-block mb-5">
              <img src="/eagle_logo_cropped.png" alt="Emcee Sons" className="h-12 w-auto" />
            </div>
            <p className="text-sm text-white/50 leading-relaxed" style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 300 }}>
              Super Stockist for Eagle Diaries. Premium diaries, planners & journals since 1976.
            </p>
          </div>
          <div>
            <div className="flex items-center gap-3 mb-4">
              <MapPin className="w-4 h-4 text-[#C8A23A]" />
              <span className="text-xs tracking-[0.15em] uppercase text-[#C8A23A] font-semibold" style={{ fontFamily: "'Outfit', sans-serif" }}>Visit Us</span>
            </div>
            <p className="text-sm text-white/50 leading-relaxed" style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 300 }}>29, Avenue Rd, Sri Krishna Building,<br />Cubbonpete, Bengaluru 560002</p>
          </div>
          <div>
            <div className="flex items-center gap-3 mb-4">
              <Phone className="w-4 h-4 text-[#C8A23A]" />
              <span className="text-xs tracking-[0.15em] uppercase text-[#C8A23A] font-semibold" style={{ fontFamily: "'Outfit', sans-serif" }}>Call Us</span>
            </div>
            <a href="tel:+919343716059" className="text-sm text-white/50 hover:text-white transition-colors" style={{ fontFamily: "'Outfit', sans-serif" }}>+91 93437 16059</a>
            <div className="flex items-center gap-3 mb-4 mt-6">
              <Clock className="w-4 h-4 text-[#C8A23A]" />
              <span className="text-xs tracking-[0.15em] uppercase text-[#C8A23A] font-semibold" style={{ fontFamily: "'Outfit', sans-serif" }}>Hours</span>
            </div>
            <p className="text-sm text-white/50" style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 300 }}>Mon – Sat: 10:30 AM – 8:30 PM</p>
          </div>
          <div>
            <h4 className="text-xs tracking-[0.15em] uppercase text-[#C8A23A] font-semibold mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>Quick Links</h4>
            <div className="flex flex-col gap-3">
              <Link to="/about" className="text-sm text-white/50 hover:text-white transition-colors" style={{ fontFamily: "'Outfit', sans-serif" }}>About Us</Link>
              <Link to="/shop" className="text-sm text-white/50 hover:text-white transition-colors" style={{ fontFamily: "'Outfit', sans-serif" }}>Shop</Link>
              <Link to="/contact" className="text-sm text-white/50 hover:text-white transition-colors" style={{ fontFamily: "'Outfit', sans-serif" }}>Contact</Link>
              <a href="https://www.instagram.com/newyeardiaries/" target="_blank" rel="noopener noreferrer" className="text-sm text-white/50 hover:text-white transition-colors" style={{ fontFamily: "'Outfit', sans-serif" }}>Instagram</a>
            </div>
          </div>
        </div>
        <div className="border-t border-white/10 pt-8 text-center">
          <p className="text-xs text-white/30" style={{ fontFamily: "'Outfit', sans-serif" }}>&copy; {new Date().getFullYear()} Eagle Diaries — Emcee Sons Diary House. All rights reserved.</p>
          <p className="text-xs text-white/30 mt-2" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Crafted by{" "}
            <a href="https://leadz.site" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-[#C8A23A] transition-colors">
              leadz.site
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
